module.exports = __webpack_public_path__ + "static/4-c98b64f442aa828df5e19dd07dcefc97.png";